import React, { Fragment } from "react";

export enum MessageAlertType {
    Error,
    Warning,
    Information
}

export interface IMessageAlertProperties {
    type?: MessageAlertType;

    // Used for the Bootstrap Alert to style the Div. See: https://getbootstrap.com/docs/4.0/components/alerts/
    alertCssClassSuffix?: string;

    // The message to output.
    message?: string;

    // The HTML to include in the alert.
    messageContent?: JSX.Element | null;
}

/**
 * Displays a messsage alert using Bootstrap styling.
 * @param props Properties to change how the message is displayed.
 */
const MessageAlert: React.FC<IMessageAlertProperties> = (props) => {
    // Default to information for the alert css class.
    // See Bootstrap Alerts for details: https://getbootstrap.com/docs/4.0/components/alerts/
    let alertCssClassSuffix: string = props.alertCssClassSuffix || getAlertCssClassSuffixFromType();

    function getAlertCssClassSuffixFromType(): string {
        let result: string = "";

        // Default to information if not specified.
        let type: MessageAlertType = props.type === undefined ? MessageAlertType.Information : props.type;

        switch (+type) {
            case MessageAlertType.Error: {
                result = "danger";
                break;
            }
            case MessageAlertType.Warning: {
                result = "warning";
                break;
            }
            default:
            case MessageAlertType.Information: {
                result = "info";
                break;
            }
        }

        return result;
    }

    function alertContent(): JSX.Element | null {
        if (!props.message && !props.messageContent) {
            return null;
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className={`alert alert-${alertCssClassSuffix}`} role="alert">{props.message || props.messageContent}</div>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            {alertContent()}
        </Fragment>
    );
}

export default MessageAlert
